import { EnumBase } from 'hay-core-react';
import CATALOGO_TEMAS, { chaveDoTema } from './catalogoTemas';

class TemplateTemaEnum extends EnumBase {
  constructor() {
    super(
      CATALOGO_TEMAS.map((tema) => chaveDoTema(tema.id)),
      'main.template.tema.lara-light.indigo',
    );
    this.groupedKeys = [
      'main.template.tema.lara-light',
      'main.template.tema.lara-dark',
      'main.template.tema.vela',
      'main.template.tema.arya',
      'main.template.tema.saga',
      'main.template.tema.viva',
    ];
  }
}

export default new TemplateTemaEnum();
